import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { quoteForId } from '../../api/quotes';
import { HomeLayouts } from '../../components/layouts/HomeLayouts';
import Loading from '../../components/Loading';
import CTA from '../../components/CTA';
import { getDisplayDate } from '../../utils/dates';
import styles from '../NewOrder/components/Confirmation/confirmation.module.scss';

export const QuotesConfirmation = () => {
  const { token } = useSelector((state) => state.auth);
  const { id } = useParams();
  const [quote, setquote] = useState(null);
  const [details, setDetails] = useState(null);
  const [loading, setloading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadQuote();
  }, []);

  const loadQuote = async () => {
    const resp = await quoteForId(token, id);
    if (resp.ok) {
      setquote(resp.data);
      setDetails([
        {
          label: 'Proveedor:',
          value: resp.data.nameSupplier,
        },
        {
          label: 'Fecha cotización:',
          value: getDisplayDate(resp.data.createdAt),
        },
      ]);
      setloading(false);
    } else {
      setquote(null);
      setloading(false);
    }
  };

  if (loading) return <HomeLayouts><Loading /></HomeLayouts>;

  return (
    <HomeLayouts>
      <div className={styles.content}>
        <div className={styles.mainContainer}>
          <h1 className={styles.title}>¡Cotización Confirmada!</h1>
          <h2 className={styles.subtitle}>
            Has aceptado la cotización de{' '}
            <strong>{quote?.nameSupplier}</strong>.
          </h2>
          <div className={styles.detailsContainer}>
            <h3 className={styles.orderNumber}>Cotización: {quote?.code}</h3>

            {details && details.map((detail) => (
              <div className={styles.detail} key={detail.label}>
                <span className={styles.label}>{detail.label}</span>
                <span className={styles.value}>{detail.value}</span>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.ctaContainer}>
          <CTA
            text="Ir a Mis Cotizaciones"
            isDisabled={false}
            onClick={() => navigate('/cotizaciones')}
          />
        </div>
      </div>
    </HomeLayouts>
  );
};
